import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import GlobalSearchCommonUtility from '@sparta.global-gt.utilities/global-search-common-utility/dist/es6.js';
import GlobalSearchJcrUtility from '@sparta.global-gt.utilities/global-search-jcr-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import spartaSpinnerUtility from '@sparta.global.utilities/sparta-spinner-utility/dist/es6.js';
import GlobalSearchTrackingUtility from '@sparta.global-gt.utilities/global-search-tracking-utility/dist/es6.js';
import { cardHelper } from '@sparta.global.helpers/card-helper/dist/es6.js';
import { spinner } from '@sparta.global.helpers/spinner-helper/dist/es6.js';
import spartaPaginationUtility from '@sparta.global.utilities/sparta-pagination-utility/dist/es6.js';
import { paginationHelper } from '@sparta.global.helpers/pagination-helper/dist/es6.js';
import spartaTransportUtility from '@sparta.global.utilities/sparta-transport-utility/dist/es6.js';
import GlobalSearchBrainUtility from '@sparta.global-gt.utilities/global-search-brain-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

/**
* A class that binds data with the view and provide all client side behaviour for
* search results layer.
*/
class ResultsController {
  /**
  * Creates an instance of ResultsController.
  * @param {object} options - used to initialize module properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(options) {
    this.resultsView = options.view;
    this.resultsModel = options.model;
    this.moduleInstance = options.moduleInstance;
    this.container = options.container;
    this.cardId = '#global-search-results-flyout-wrapper';
    this.resultsContainerClass = '.spa-global-search-results-container';
    this.inputTextboxContainerClass = '.spa-global-search-form--lg';
    this.widgetContainerId = '#spa-global-search-widget-container';
    this.submitButtonClass = '.submit';
    this.resultsContainer = null;
    this.flyoutWrapperElem = null;
    this.viewport = 'large';
    const mediaQueryData = this.moduleInstance.Store.getData('currentMQ');
    //set viewport for responsive page | for non-responsive keep large
    if (mediaQueryData && document.getElementsByTagName('body')[0]?.dataset?.spartaVersion) {
      this.viewport = mediaQueryData.viewport;
    }
    this.queryRequest = null;
    this.spinner = new spartaSpinnerUtility();
    //this.error = new spartaMessageUtility();
    this.data = null;
    this.pageIndex = 0;
    this.tracking = new GlobalSearchTrackingUtility({
      isAuth: this.moduleInstance.isAuth,
      moduleInstance: this.moduleInstance
    });
    this.invoker = null;
  }

  /**
  * Called by module to initialize controller behaviour
  * @param {object} options - used to initialize behaviour.
  * @returns {void}
  */
  init(options = {}) {
    this.attachEvents(options);
    document.addEventListener('gt.globalsearch.ui-show', args => {
      this.reRender = true; // when viewport changes this will render the result module markup
      this.widgetContainerId = '#'.concat(args.detail.container);
    });
  }

  /**
  * Subscribe to standard dom and custom events
  * @returns {void}
  */
  attachEvents() {
    this.moduleInstance.Events.sub('global.search.request-updated', $.proxy(this.handleRequestUpdated, this));
    if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout') {
      this.moduleInstance.Events.sub('global.search.query-updated', $.proxy(this.hidePopup, this));
      this.moduleInstance.Events.sub('global.search.escape-clicked', $.proxy(this.hidePopup, this));
      this.moduleInstance.Events.sub('global.search.focus-out', $.proxy(this.hidePopup, this));
      $(document).on('mouseup', $.proxy(this.handleBodyClick, this));
      $(document).on('keyup', $.proxy(this.handleBodyKeyup, this));
      this.moduleInstance.Events.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, data => {
        if (data && data.data && data.data.viewport) {
          this.hide();
        }
      });
    }
    if (this.tracking) {
      this.tracking.registerEventHandlers();
    }
  }

  /**
  * Handler for global.search.results-received event and renders search results.
  * @param {object} args - event arguments .
  * @returns {void}
  */
  handleRequestUpdated(args) {
    this.pageIndex = 0;
    if (args && args.data) {
      if (this.reRender) {
        this.resultsContainer = null;
        this.reRender = false;
      }
      const invoker = args.data.invoker;
      if (invoker && $(invoker).length > 0) {
        if ($(invoker)[0].tagName.toLowerCase() === 'input' || $(invoker)[0].tagName.toLowerCase() === 'button') {
          this.invoker = invoker;
        } else if ($(invoker).parents('button').length > 0) {
          this.invoker = $(invoker).parents('button');
        } else {
          this.invoker = null;
        }
      }
      this.render(args.data);
    }
  }

  /**
  * Renders search results container inside a target and request data for the updated search query
  * @param {object} options - data that need to be binded to the view.
  * @returns {void}
  */
  render(options = {}) {
    this.queryRequest = options;
    if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout') {
      this.container = options.target;
    }
    if (!this.resultsContainer) {
      const view = this.resultsView.getView();
      const data = this.resultsModel.getUIData({
        query: options.query
      });
      if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout') ;
      if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'inline') ;
      const html = view({
        data: data
      }, {
        helpers: {
          cardHelper,
          spinner
        },
        partials: {}
      });
      $(this.container).find(this.resultsContainerClass).remove();
      $(this.container).append(html);
      this.resultsContainer = $(this.container).find(this.resultsContainerClass);
      if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout') {
        $(this.container).find(this.cardId).find('.spa-card__body').html('');
        $(this.container).find(this.cardId).find('.spa-card__body').append(this.resultsContainer);
        $(this.container).find(this.cardId).find('.spa-card__dismissible').on('click', $.proxy(this.hidePopup, this));
        $(document.body).on('keyup', $.proxy(this.handleNavigation, this));
        if (this.moduleInstance.inputExperience.toLowerCase() === 'header' && this.viewport.indexOf('small') > -1) {
          $(this.container).find(this.cardId).removeClass('spa-card spa-card--medium spa-card--overlay');
        }
      }
      if (this.moduleInstance.inputExperience && this.moduleInstance.inputExperience.toLowerCase() !== 'stage') {
        $(this.container).find(this.cardId).addClass('spa-global-search-flyout-pos--right');
      }
    }
    if (this.viewport.indexOf('medium') > -1 && this.moduleInstance.inputExperience && this.moduleInstance.inputExperience.toLowerCase() === 'header') {
      this.inputContainer = this.resultsContainer.find('#global-search-input-container-md');
      if ($(this.invoker)[0].tagName.toLowerCase() === 'input') {
        this.moduleInstance.Events.pub('global.search.medium-breakpoint', {
          target: this.inputContainer,
          focusInput: true
        });
      } else {
        this.moduleInstance.Events.pub('global.search.medium-breakpoint', {
          target: this.inputContainer,
          focusButton: true
        });
      }
    }
    if (!this.queryRequest.query) {
      this.show('.empty-search');
      this.tracking.registerEventHandlers();
      if (this.invoker) {
        $(this.invoker).off('keydown.searchresults').on('keydown.searchresults', $.proxy(this.handleKeydown, this));
      }
    } else {
      this.show('.throbber');
      this.spinner.show('.throbber');
      let rows = this.moduleInstance.jcrHelper.getSettings({
        key: 'suggestedSearchLimit'
      });
      let start = 0;
      if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'inline') {
        rows = this.moduleInstance.jcrHelper.getSettings({
          key: 'searchItemLimitInline'
        });
        start = this.pageIndex * this.moduleInstance.jcrHelper.getSettings({
          key: 'searchItemLimitInline'
        });
      }
      const request = {
        query: options.query,
        start: start,
        rows: rows,
        checkSpelling: this.isNullOrEmpty(options.checkSpelling) ? true : options.checkSpelling,
        lang: this.moduleInstance.lang
      };
      this.resultsModel.getServiceData(request).then($.proxy(this.getDataSuccess, this), $.proxy(this.getDataFailed, this));
    }
  }

  /**
  * Renders UI as per data received from model and also notify other parties about availability
  * of new data by raising "global.search.results-received" event
  * @param {object} data - data that need to be binded to the view.
  * @returns {void}
  */
  getDataSuccess(data) {
    if (this.moduleInstance.resultsExperience.toLowerCase() === 'flyout' && $(this.cardId).is(':visible') === false) {
      return;
    }
    this.data = data;

    //Track searched query term
    this.tracking.handleResultsUpdated(this.data);
    this.spinner.hide();
    this.hide('.throbber');
    if (this.invoker) {
      $(this.invoker).off('keydown.searchresults').on('keydown.searchresults', $.proxy(this.handleKeydown, this));
    }

    // null response returned for given search text
    if (data.error) {
      this.show('.outage');
      this.tracking.registerEventHandlers();
      //$('.outage').find('.error').remove();
      //$('.error-message').html('');
      //this.error.showErrorMessage('.error-message', data.ErrorMsg, '', {});
      return;
    }

    // no results returned for given search text
    if (data.qa.answer.length === 0 && data.siteSearch.results.length === 0) {
      this.show('.no-results');
      this.tracking.registerEventHandlers();
      return;
    }
    this.moduleInstance.Events.pub('global.search.results-received', {
      response: data,
      target: $(this.container)
    });
    this.updateDescribeBy(true);

    //Track qa answer & site search based on user interaction
    this.tracking.registerEventHandlers();
    const autoCorrect = $('.spa-global-search-managed-top-result--suggest-link');
    autoCorrect.on('click', $.proxy(function (event) {
      this.moduleInstance.Events.pub('global.search.request-updated', {
        query: this.queryRequest.query,
        target: this.container,
        checkSpelling: false,
        invoker: this.invoker
      });
    }, this));
    if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'inline') {
      let paginationSettings = $.extend(this.data.pagination, {
        totalRecords: data.siteSearch.total > 50 ? 50 : data.siteSearch.total,
        index: this.pageIndex
      });
      const paginationMarkup = paginationHelper(paginationSettings);
      let container = document.getElementById('global-search-result-pagination');
      if (container) {
        container.innerHTML = paginationMarkup;
      }
      let obj = new spartaPaginationUtility();
      obj.init(Object.assign(paginationSettings, {
        id: '#advancedPagination',
        domContainer: '#global-search-result-pagination',
        callback: $.proxy(this.handlePageChange, this)
      }));
    }
  }

  /**
  * Renders UI as per error data received from model
  * @param {object} data - data that need to be binded to the view.
  * @returns {void}
  */
  getDataFailed(data) {
    this.spinner.hide();
    this.hide('.throbber');
    this.show('.outage');
    this.tracking.registerEventHandlers();
    //$('.outage').find('.error').remove();
    //$('.error-message').html('');
    //this.error.showErrorMessage('.error-message', data.ErrorMsg, '', {});
  }

  /**
   * Handles body click.
   * @param {event} event param to be used to get target element.
   * @returns {void}
   */
  handleBodyClick(event) {
    event.stopPropagation();
    if (event.target && this.checkIfExternalClick(event.target)) {
      this.hide();
    }
  }

  /**
   * check for external click outside popup.
   * @param {event} element element to be checked for external click.
   * @returns {void}
   */
  checkIfExternalClick(element) {
    if ($(element).parents(this.cardId).length === 0) {
      return true;
    }
    return false;
  }

  /**
   * check for external element outside of widget.
   * @param {event} element element to be checked for external click.
   * @returns {void}
   */
  checkIfExternalToWidget(element) {
    if ($(element).parents(this.widgetContainerId).length === 0) {
      return true;
    }
    return false;
  }
  handlePageChange(event, args) {
    //this.data.pagination.index = event.index;
    let paginationSettings = $.extend(this.data.pagination, {
      index: event.index
    });
    this.pageIndex = event.index;
    const paginationMarkup = paginationHelper(paginationSettings);
    var container = document.getElementById('global-search-result-pagination');
    container.innerHTML = paginationMarkup;
    let obj = new spartaPaginationUtility();
    obj.init(Object.assign(paginationSettings, {
      id: '#advancedPagination',
      domContainer: '#global-search-result-pagination',
      callback: $.proxy(this.handlePageChange, this)
    }));
    $("html, body").animate({
      scrollTop: "0"
    });
    if (this.data.spellingCorrected && this.data.spellingCorrected === true && this.queryRequest.query != this.data.correctedQuery)
      // incase of spelling issue, page change makes service request using correct query. Same corrected query gets set to the input field
      {
        this.queryRequest.query = this.data.correctedQuery;
        $('#nav-search-query').val(this.data.correctedQuery);
      }
    this.render(this.queryRequest);
  }

  /**
   * Handles down arrow key press event and move focus into the popup
   * Event subscriber must verify query and remove forbidden characters before updating query.
   * @param {events} events - holds event related properties and methods.
   * @returns {void}
   */
  handleKeydown(events) {
    if (events.keyCode === 40) {
      $(this.resultsContainerClass).find('.spa-global-search--sections').find("[tabindex='0']:visible").first().focus();
      //$(this.resultsContainerClass).find('.spa-global-search--sections').find("[tabindex='-1']:visible").first().css('border', '1px solid blue');
      events.preventDefault();
    }
  }

  /**
  * Display only section of Search Result that is passed in a argument and hide rest sections.
  * @param {string} sectionName - Css class applied to the section that need to be showned.
  * @returns {void}
  */
  show(sectionName) {
    this.hide();
    $(this.resultsContainerClass).show();
    $(this.cardId).show();
    $(this.resultsContainerClass).children().children(sectionName).show();
    this.updateDescribeBy(true);

    //Help Overview : Show input in default state - stage/flyout use case
    if ($(this.container).find(this.inputTextboxContainerClass) && this.moduleInstance.inputExperience.toLowerCase() === 'stage' && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout') {
      $(this.container).find(this.inputTextboxContainerClass).addClass('show');
    }
  }

  /**
  * Hide specific or all section of Search Result.
  * @returns {void}
  */
  hide(sectionName) {
    if (sectionName) {
      $(this.resultsContainerClass).children().children(sectionName).hide();
    } else {
      $(this.resultsContainerClass).hide();
      if (this.invoker) {
        $(this.invoker).attr('aria-expanded', 'false');
        this.updateDescribeBy(false);
      }
      $(this.cardId).hide();
      $(this.resultsContainerClass).find('.spa-global-search--sections').children().hide();

      //Help Overview : Show input in default state - stage/flyout use case
      if ($(this.container).find(this.inputTextboxContainerClass) && this.moduleInstance.inputExperience.toLowerCase() === 'stage' && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout' && $(this.cardId).is(':visible')) {
        $(this.container).find(this.inputTextboxContainerClass).removeClass('show');
      }
    }
    $(this.container).find(this.cardId).find('.spa-card__foot').hide();
    $(this.container).find('#global-search-result-pagination').hide();
  }

  /**
  * Hide entire card used for flyout Search Result.
  * @returns {void}
  */
  hidePopup(args) {
    if (args.event === "global.search.escape-clicked" && this.invoker) {
      if (this.viewport.indexOf('medium') === -1 && $(this.cardId).is(':visible')) {
        // for large and small breakpoints
        $(this.invoker).focus();
      }
    }
    this.hide();
  }

  /**
   * handles keyup event to capture tab press that will set focus on the 
   * @param {event} event to be used to publish the event.
   * @returns {void}
   */
  handleBodyKeyup(event) {
    if (event.target && event.target.tagName.toLowerCase() !== 'html' && event.target.tagName.toLowerCase() !== 'body' && $(this.cardId).is(':visible') && this.checkIfExternalToWidget(event.target)) {
      this.hide();
    }
  }

  /**
  * Update aria-describedby for invoker.
  * @returns {void}
  */
  updateDescribeBy(isSet) {
    if (isSet && this.invoker) {
      $(this.invoker).attr('aria-expanded', 'true');
      let id = $(this.resultsContainerClass).find('.spa-global-search--sections').find("[tabindex='0']:visible").first().attr('id');
      if (id) {
        $(this.invoker).attr('aria-describedby', id);
      } else {
        $(this.invoker).attr('aria-describedby', '');
      }
    } else {
      $(this.invoker).attr('aria-describedby', '');
    }
  }

  /**
  * Check if given object is null or empty
  * @param {object} obj - object to be checked.
  * @returns {bool}
  */
  isNullOrEmpty(obj) {
    return obj === null || typeof obj === 'undefined' || obj === '';
  }
}

/**
* A class that fetch handlebars view and provide all view or markup related processing.
*/
class ResultsView {
  /**
  * Creates an instance of ResultsView.
  * @param {object} options - used to initialize view properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(options) {
    this.templateId = options.settings.templateId;
    this.moduleInstance = options.moduleInstance;
  }

  /**
  * Called by controller to fetch view template that needs to be binded with the data.
  * @returns {object}
  */
  getView() {
    return moduleConfig.partials[this.templateId];
  }
}

/**
* A class that deals with data and its processing.
*/
class ResultsModel {
  /**
  * Creates an instance of ResultsModel.
  * @param {object} options - used to initialize module properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(options) {
    this.settings = options.settings;
    this.moduleInstance = options.moduleInstance;
    this.jcrHelper = this.moduleInstance.jcrHelper;
    this.brain = new GlobalSearchBrainUtility({
      isAuth: this.moduleInstance.isAuth,
      moduleInstance: this.moduleInstance
    });
    if (this.moduleInstance.isAuth) {
      this.searchUrl = this.jcrHelper.getUrl({
        key: 'searchAuth',
        secureAlways: true
      });
    } else {
      this.searchUrl = this.jcrHelper.getUrl({
        key: 'searchUnAuth',
        secureAlways: true
      });
    }
    this.query = '';
    this.viewport = 'large';
    const mediaQueryData = this.moduleInstance.Store.getData('currentMQ');
    //set viewport for responsive page | for non-responsive keep large
    if (mediaQueryData && document.getElementsByTagName('body')[0]?.dataset?.spartaVersion) {
      this.viewport = mediaQueryData.viewport;
    }
  }

  /**
  * Fetch and return non service data that is required for UI rendering
  * @returns {object}
  */
  getUIData(options = {}) {
    const labels = this.jcrHelper.getAllLabels();
    const searchData = this.jcrHelper.getSearchData();
    const resultsCardsSettings = searchData.resultsCardsSettings;
    const resultsSpinner = searchData.resultsSpinner;
    const pagination = JSON.parse(JSON.stringify(searchData.pagination));
    const links = {
      helpSupport: this.moduleInstance.isAuth ? this.brain.fullUrl('custservice') : this.jcrHelper.getUrl({
        key: 'helpSupportUnAuth'
      }),
      contactUs: this.moduleInstance.isAuth ? this.brain.fullUrl('contactus') : this.jcrHelper.getUrl({
        key: 'contactUsUnAuth'
      })
    };
    const config = {
      isAuth: this.moduleInstance.isAuth
    };
    return {
      labels,
      resultsCardsSettings,
      resultsSpinner,
      links,
      config,
      pagination
    };
  }

  /**
  * Fetch and return service data that is required for rendering
  * @param {object} options - parameters required to create service request
  * @returns {promise}
  */
  getServiceData(options = {}) {
    this.ps = $.Deferred();
    try {
      options.query = options.query.replace(/<|>/g, '');
      this.query = options.query;
      this.request = this.getRequest(options);
      const transportObj = {
        cache: false,
        method: "POST",
        data: JSON.stringify(this.request),
        dataType: "json",
        contentType: "application/json",
        url: this.searchUrl,
        xhrFields: {
          withCredentials: true
        },
        success: $.proxy(this.successCallback, this),
        error: $.proxy(this.failureCallback, this)
      };
      let arrSearchContext = window.location.pathname && window.location.pathname.length > 1 ? window.location.pathname.split('/') : null;
      let searchContext = arrSearchContext && arrSearchContext.length > 1 ? arrSearchContext[1] : null;
      if (searchContext) {
        transportObj.headers = {
          "search-context": searchContext
        };
      }
      spartaTransportUtility.subscribe(transportObj);
    } catch (ex) {
      this.failureCallback();
    }
    return this.ps;
  }

  /**
  * create and return service request
  * @param {object} options - parameters required to create service request
  * @returns {object}
  */
  getRequest(options = {}) {
    const request = {
      query: `${GlobalSearchCommonUtility.string.insecure(options.query)}`,
      start: options.start,
      rows: options.rows,
      checkSpelling: options.checkSpelling,
      channel: options.channel,
      // null always as BAU
      device: options.device,
      // null always as BAU
      context: options.context,
      // null always as BAU
      lang: options.lang
    };
    return request;
  }

  /**
  * Success callback function to be passed to transport utility
  * @param {object} data - response from service
  * @returns {void}
  */
  successCallback(data) {
    let processedData = this.processData(data);
    processedData = $.extend(processedData, this.getUIData({}));
    if (!processedData.error) {
      processedData.config.showCorrection = processedData.spellingCorrected;
      processedData.query = processedData.spellingCorrected ? processedData.correctedQuery : this.query;
      processedData.rawQuery = this.query;
      processedData.qa.answer = GlobalSearchCommonUtility.string.cleanString(processedData.qa.answer);
      if (processedData.qa.answer && processedData.qa.answer.length > 0) {
        processedData.config.isAnswerPresent = true;
      } else {
        processedData.config.isAnswerPresent = false;
      }
      processedData.resultsCardsSettings.foot.data[0].URL = this.moduleInstance.isAuth ? this.jcrHelper.getUrl({
        key: 'fullSearchPageAuth'
      }) : this.jcrHelper.getUrl({
        key: 'fullSearchPageUnAuth'
      });
      processedData.resultsCardsSettings.foot.data[0].URL += '?state=' + encodeURIComponent(processedData.query.replace(/\'/gi, '')).replace(/\*/gi, '%2A');
    }
    this.ps.resolve(processedData);
  }

  /**
  * Failure callback function to be passed to transport utility
  * @returns {void}
  */
  failureCallback() {
    let data = {
      error: 'service',
      ErrorMsg: this.jcrHelper.getLabel({
        key: 'outageIntro'
      })
    };
    data = $.extend(data, this.getUIData({}));
    this.ps.reject(data);
  }

  /**
  * Process and return data that is passed to this function
  * @param {object} response - used to pass data that need to be processed
  * @param {object} request - used to pass original request object
  * @returns {object}
  */
  processData(response, request = {
    page: 1
  }) {
    const formattedResponse = {};
    if (!response) {
      formattedResponse.error = 'service';
      return formattedResponse;
    }

    // spell-check
    formattedResponse.spellingCorrected = response.spellingCorrected;
    if (response.hasOwnProperty('correctedQuery')) {
      formattedResponse.correctedQuery = response.correctedQuery;
    }
    // related questions
    formattedResponse.related = [];
    if (response.related) {
      const related = this.namedListGet(response.related, 'answer');
      for (let i = 0; i < related.length; i++) {
        formattedResponse.related.push(this.namedListFirst(related[i], 'query'));
      }
    }
    formattedResponse.qa = this.processQaSearchData(response);
    formattedResponse.siteSearch = this.processSiteSearchData(response);
    formattedResponse.queryId = this.processId(response);
    formattedResponse.page = typeof request.page === 'number' ? request.page : 1;
    return formattedResponse;
  }

  /**
  * Create meaningful url for Brain placeholders present inside the markup from service response
  * @param {string} html - markup with Brain placeholders in it
  * @param {string} query - search query string
  * @returns {string}
  */
  renderBrainLinks(html, query) {
    const result = html.replace(/href=((['"])brain:([^'"]*)\2|brain:([^ >"']*))/g, $.proxy(function (match, attribute, quote, quotedTarget, unquotedTarget) {
      return `href="${this.brain.fullUrl(quotedTarget || unquotedTarget || '', GlobalSearchCommonUtility.string.insecure(query))}"`;
    }, this));
    return result;
  }

  /**
  * Process markup present in the response received from service
  * @param {object} response - service response to be processed
  * @returns {string}
  */
  processQaSearchData(response) {
    const answer = this.namedListFirst(response.answer, 'response') || '';
    return {
      answer: this.renderBrainLinks(answer, response.correctedQuery)
    };
  }

  /**
  * Process site search data received from service
  * @param {object} response - service response to be processed
  * @returns {string}
  */
  processSiteSearchData(response) {
    let i;
    let id;
    let highlighting;
    const results = response.response.docs;
    const l = results.length;
    let r = {};
    const badContentKey = 'text_content';
    if (response.highlighting) {
      for (i = 0; i < l; i++) {
        // attach highlighting to results
        id = results[i].id;
        if (response.highlighting.hasOwnProperty(id)) {
          highlighting = response.highlighting[id];
          if (highlighting.title) {
            results[i].highlightedTitle = highlighting.title[0];
          }
          if (highlighting[badContentKey]) {
            results[i].highlightedAnswer = highlighting[badContentKey].join(' ');
          }
        }
      }
    }
    for (i = 0; i < l; i++) {
      r = results[i];
      // Escape any double-encoded HTML entities.
      // Attempt to substitute entities first.
      const commonUtil = GlobalSearchCommonUtility;
      r.highlightedTitle = commonUtil.string.renderHtmlEntities(r.highlightedTitle);
      r.highlightedAnswer = commonUtil.string.renderHtmlEntities(r.highlightedAnswer);
      // Then clean out any bad unicode.
      r.highlightedTitle = commonUtil.string.cleanString(r.highlightedTitle);
      r.highlightedAnswer = commonUtil.string.cleanString(r.highlightedAnswer);
      r.highlightedTitlePlainText = $('<span>' + r.highlightedTitle + '</span>').text();
      // Remove OOL from any deep links
      if (r.url && r.url.match(/answer_type=olb-url/)) {
        delete r.language;
      }
    }
    return {
      total: response.response.numFound,
      first: response.response.start,
      results
    };
  }

  /**
  * Process chatcontext data received from service
  * @param {object} response - service response to be processed
  * @returns {string}
  */
  processId(response) {
    return (this.namedListFirst(response.chatcontext, 'cid') || '').replace('java.util.UUID:', '');
  }
  namedListGet(array, key) {
    const keys = {};
    if (array) {
      let i;
      const l = array.length;
      for (i = 0; i < l - 1; i += 2) {
        if (keys.hasOwnProperty(array[i])) {
          keys[array[i]].push(array[i + 1]);
        } else {
          keys[array[i]] = [array[i + 1]];
        }
      }
    }
    if (!key || !keys[key]) {
      return [];
    }
    return keys[key];
  }
  namedListFirst(array, key) {
    const list = this.namedListGet(array, key);
    return list.length === 0 ? null : list[0];
  }
}

/**
 * A class that binds data with the view and provide all client side behaviour
 * for QA section of search results layer.
 */
class QaAnswerController {
  /**
  * Creates an instance of QaAnswerController.
  * @param {object} options - used to initialize module properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(options) {
    this.qaView = options.view;
    this.qaModel = options.model;
    this.moduleInstance = options.moduleInstance;
    this.container = options.container;
    this.qaContainerClass = '.managed-content';
    this.qaContainer = null;
    this.cardId = '#global-search-results-flyout-wrapper';
  }

  /**
  * Called by module to initialize controller behaviour
  * @param {object} options - used to initialize behaviour.
  * @returns {void}
  */
  init(options = {}) {
    this.attachEvents(options);
  }

  /**
  * Subscribe to standard dom and custom events
  * @returns {void}
  */
  attachEvents() {
    this.moduleInstance.Events.sub('global.search.results-received', $.proxy(this.handleResultsReceived, this));
  }

  /**
  * Handler for global.search.results-received event and renders site search section of search results
  * @param {object} args - event arguments.
  * @returns {void}
  */
  handleResultsReceived(args) {
    this.container = args.data.target;
    if (args.data.response.qa.answer.length === 0) {
      $(this.qaContainerClass).hide();
    } else {
      $(this.qaContainerClass).show();
      this.render(args.data);
      if (this.moduleInstance.resultsExperience) {
        if (this.moduleInstance.resultsExperience.toLowerCase() === 'flyout') {
          $(this.container).find('.spa-card__foot').show();
          $(this.qaContainerClass).find('.qa-answer.live-results').removeClass('spa-card spa-card--medium spa-card--overlay show-search');
        } else {
          //Show card utility like UI experience for managed content on page inline use case
          $(this.qaContainerClass).find('.qa-answer.live-results').addClass('spa-card spa-card--medium spa-card--overlay show-search');
        }
      }
    }
  }

  /**
  * Renders site search section of search results
  * @param {object} data - data that need to be binded to the view.
  * @returns {void}
  */
  render(data = {}) {
    const view = this.qaView.getView();
    if (view) {
      const target = this.container.find(this.qaContainerClass);
      $(target).html(view({
        data: data.response
      }));
      const container = target.find('.spa-global-search-managed-top-result-ans--container');
      this.qaView.modifyBrains(container, this.moduleInstance.isAuth);
      this.qaView.formatTables(container, data.response.labels);
      this.qaView.massageAda(container);
      this.qaView.massageFullImage(container);
      this.qaView.linkFootnotes(container, data.response.labels);
    }
  }
}

/**
* A class that fetch handlebars view and provide all view or markup related processing.
*/
class QaAnswerView {
  /**
  * Creates an instance of QaAnswerView.
  * @param {object} options - used to initialize view properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(options) {
    this.settings = options.settings;
    this.moduleInstance = options.moduleInstance;
  }

  /**
  * Called by controller to fetch view template that needs to be binded with the data
  * @returns {object} - applicable template
  */
  getView() {
    return moduleConfig.partials['results-qa-answers'];
  }
  modifyBrains(container, authenticated) {
    var $links = $('a', container),
      i,
      $link,
      target;
    const brain = new GlobalSearchBrainUtility({
      isAuth: this.moduleInstance.isAuth,
      moduleInstance: this.moduleInstance
    });
    for (i = 0; i < $links.length; i++) {
      $link = $links.eq(i);
      target = brain.newWindow($link.attr('href'));
      if (target !== '') {
        $link.attr('target', target);
      }
      if (authenticated === true) {
        $link = brain.toggleUrl($link, 'auth');
      }
    }
  }
  formatTables(container, labels) {
    const util = GlobalSearchCommonUtility;
    var regExStripNumber = /(\s{1}\-{1}\s{1}\d{4})$/gim,
      formatAccounts = function (marker, $container) {
        $(marker, $container).each(function () {
          var $account = $(this),
            account = $account.text(),
            $name = $account.parents('tr').not('.subaccount').find('td.name'),
            simpleName = $name.length > 0 ? $name.text().replace(regExStripNumber, '') : '',
            $unmasked = $('<span class="unmasked"></span>'),
            $mask = $('<span class="mask"></span>'),
            $masked = $('<span class="masked"></span>');
          $name.text($.trim(simpleName));
          $unmasked.text(account);
          $mask.text(util.string.repeat('X', account.length - 4));
          $masked.text(account.substr(account.length - 4)).prepend($mask);
          $account.empty().append($unmasked).append($masked);
        });
        return $container;
      },
      toggleContent = function ($target, container) {
        var $container = $($target, container),
          action = $container.attr('data-action'),
          actionTarget = $container.attr('data-action-target'),
          $genericControl = $('<a href="javascript:void(0);"></a>'),
          $controls = $('[data-action-controls]', $container).addClass('controls');
        $controls.each(function () {
          var $controlOn,
            $controlOff,
            rowCount = $('tbody tr', $container).length,
            actionObjectLabel,
            actionObjectText,
            actionVerbShow,
            actionVerbHide;
          actionObjectLabel = "noun" + actionTarget;
          actionObjectText = labels[actionObjectLabel];
          actionVerbShow = util.string.entitiesToCharacters(labels.verbShow);
          actionVerbHide = util.string.entitiesToCharacters(labels.verbHide);
          actionObjectText = util.string.entitiesToCharacters(actionObjectText);
          if (typeof action !== "string" || typeof actionObjectText !== "string" || typeof actionObjectText === "undefined" || rowCount === 0) {
            return $container;
          }
          switch (action) {
            case "mask":
              $controlOn = $genericControl.clone().addClass("unmasker").text(actionVerbShow + " " + actionObjectText);
              $controlOff = $genericControl.clone().addClass("masker").text(actionVerbHide + " " + actionObjectText);
              $("tbody tr .account", $container).append($controlOn).append($controlOff);
              $("tbody tr .account .unmasker", $container).click(function () {
                $("tbody tr", $container).removeClass("unmasking");
                $(this).closest("tr").addClass("unmasking");
              });
              $("tbody tr .account .masker", $container).click(function () {
                $(this).closest("tr").removeClass("unmasking");
              });
              break;
          }
        });
        return $container;
      },
      formatAmounts = function (marker, $container) {
        $(marker, $container).each(function () {
          var $amount = $(this),
            value = util.string.formatAccounting(util.string.formatDecimal($amount.text())),
            $units = $('<span class="unit">$</span>');
          $amount.text(value).prepend($units);
        });
        return $container;
      },
      addSubAccounts = function (marker, $container) {
        $(marker, $container).each(function () {
          var $tr = $(this),
            parentAccount = $tr.data('account-primary'),
            $parent = $('tr', $container).filter(function () {
              return $(this).data('account') === parentAccount;
            }),
            $siblings = $(marker, $container).filter(function () {
              return $(this).data('account-primary') === parentAccount;
            }),
            $youngest = $siblings.last();
          $parent.addClass('has-subaccount');
          $youngest.addClass('last');
        });
      },
      insertLabels = function ($target, container) {
        var $container = $($target, container),
          $parent = $container.parent(),
          html = '',
          id = '',
          defaultId = 'insertLabelsActionId',
          i,
          marker,
          label,
          markerTarget = /(\{\{i18n\..+?\}\})/gi,
          labelTarget = /\{\{i18n\.(.+?)\}\}/gi,
          markers = [],
          specificMarker = new RegExp(),
          specificLabel = '';
        if ($container.length === 0) {
          return $target;
        }
        if ($container.attr('id')) {
          id = $container.attr('id');
        } else {
          id = defaultId;
          $container.attr('id', defaultId);
        }
        html = $parent.html();
        markers = html.match(markerTarget);
        if (markers) {
          for (i = 0; i < markers.length; i++) {
            marker = markers[i];
            label = marker.replace(labelTarget, '$1');
            specificLabel = labels[label];
            specificMarker = new RegExp(marker, 'gi');
            if (typeof specificLabel !== 'string') {
              specificLabel = '';
            }
            html = html.replace(specificMarker, specificLabel);
          }
        }
        $target = $parent.html(html).find('#' + id);
        if (id === defaultId) {
          $target.removeAttr('id');
        }
        return $target;
      },
      resizeToRight = function () {
        var $left = $(this),
          $right = $left.next('table'),
          leftHeight = $left.outerHeight(),
          rightHeight = $right.outerHeight(),
          difference = leftHeight - rightHeight;
        if (difference > 0) {
          $right.css({
            'margin-top': difference
          });
        } else {
          $left.css({
            'margin-top': 0 - difference
          });
        }
        $left.addClass('newline').add($right).addClass('balanced');
      },
      balanceRoutingTables = function ($tables, container) {
        var $container = $($tables, container),
          $left = $container.filter(':nth-child(odd)');
        $left.each(resizeToRight);
      },
      limitItems = function (container) {
        $(container).find('.limit-items').each(function () {
          var $who = $(this),
            what = $who.data('item-limit-filter') || 'nothing',
            howmuch = $who.data('item-limit-amount') || 0;
          $who.find($.trim(what) + ':gt(' + (howmuch - 1) + ')').remove();
        });
      },
      markerTable = '.search-table',
      markerAmount = 'tbody td.amount',
      markerAccount = 'tbody td.account',
      markerSubaccount = 'tbody tr.subaccount',
      $table = $(markerTable, container);
    limitItems(container);
    $table = insertLabels($table, container);
    $table = formatAmounts(markerAmount, $table);
    $table = formatAccounts(markerAccount, $table);
    $table = toggleContent($table, container);
    $table = addSubAccounts(markerSubaccount, $table);
    setTimeout(function () {
      balanceRoutingTables('table.search-routing.split', container);
    }, 0);
  }
  massageAda(container) {
    var addHidden = function () {
        var base = 'data-link',
          marker = 'ada',
          markerRegex = new RegExp('{ada(.*?)}', 'gi'),
          $elements = $(),
          $adaShell = $('<span class="ada-hidden"></span>'),
          i,
          adjustAdaMarkers = function (base, marker, container) {
            var n,
              oldAttribute,
              newAttribute,
              $els,
              e,
              $el,
              numbers = {
                'one': '1',
                'two': '2',
                'three': '3'
              };
            for (n in numbers) {
              if (numbers.hasOwnProperty(n)) {
                oldAttribute = [base, marker, n].join('-');
                newAttribute = base + '-' + marker + numbers[n];
                $els = $('[' + oldAttribute + ']', container);
                for (e = 0; e < $els.length; e++) {
                  $el = $els.eq(e);
                  $el.attr(newAttribute, $el.attr(oldAttribute)).removeAttr(oldAttribute);
                }
              }
            }
          },
          insertAda = function ($element, prefix) {
            var t,
              target,
              attribute,
              text,
              $ada = $adaShell.clone(true),
              ada,
              targets = $element.text().match(markerRegex);
            for (t = 0; t < targets.length; t++) {
              target = targets[t];
              attribute = prefix + target.replace(/({ada)(.*)(})/gi, '$2');
              text = $element.attr(attribute);
              $ada.text(text ? ' ' + text + ' ' : '');
              ada = $('<div>').append($ada).html();
              $element.removeAttr(attribute).html($element.html().replace(target, $ada.text().length ? ada : ''));
            }
          };
        adjustAdaMarkers(base, marker, container);
        $elements = $('a', container).filter(function () {
          return markerRegex.test($(this).text());
        });
        for (i = 0; i < $elements.length; i++) {
          insertAda($elements.eq(i), base + '-' + marker);
        }
      },
      addAriaToButtons = function () {
        $('.btn-bofa', container).attr('aria-role', 'button');
      };
    addHidden();
    addAriaToButtons();
  }
  massageFullImage(container) {
    var $container = $(container).filter(':first'),
      $content = $container.find('.answer'),
      $image = $content.find('img');
    if ($.trim($content.text()).length < 10) {
      $content.addClass('full-width-image');
      $image.removeAttr('style');
    }
  }
  linkFootnotes(container) {
    var markers = {
        'number': '',
        'roman': '',
        'letter': '',
        'star': '*',
        'pound': '#',
        'sectional': '&sect;',
        'dagger': '&dagger;',
        'diesis': '&Dagger;'
      },
      answer = '.answer',
      footnoteContainer = '<div class="footnotes"></div>',
      footnoteWrapper = '.footnote:contains([fn-)',
      markerWrapper = 'sup:contains([fn-)',
      connectClass = 'fn-glue',
      boundClass = 'fn-bound',
      contentClass = 'fn-content',
      attrBase = 'data-footnote',
      attrType = attrBase + '-type',
      attrOrder = attrBase + '-order',
      attrValue = attrBase + '-value',
      attrFunction = attrBase + '-function',
      attrRendered = attrBase + '-rendered',
      fnRegex = /\[fn-(.+?)-(.+?)\]/g,
      boundRegex = /\[(.+?)\]/g,
      createMarker = function (type, count) {
        var html = count,
          delimiter = '.';
        if (typeof count === 'number') {
          switch (type) {
            case 'number':
              html = count.toString();
              break;
            case 'roman':
              html = GlobalSearchCommonUtility.number.romanize(count);
              break;
            case 'letter':
              html = String.fromCharCode(96 + count);
              break;
            default:
              html = new Array(count + 1).join(markers[type]);
              delimiter = null;
              break;
          }
        } else {
          delimiter = null;
        }
        delimiter = delimiter ? '<span class="delimiter">' + delimiter + '</span>' : '';
        return '<span class="fn-' + type + '">' + html + delimiter + '</span>';
      },
      addVisualAndLink = function ($marked, marker) {
        var type = $marked.attr(attrFunction),
          $glue = $marked.find('.' + connectClass),
          glue = $marked.attr(attrBase),
          ada = labels.nounFootnote ? '<span class="ada-hidden">' + labels.nounFootnote + ' </span>' : '';
        switch (type) {
          case 'link':
            $glue.html('<a href="#' + glue + '">' + ada + marker + '</a>');
            break;
          case 'footnote':
            $glue.html('<a name="' + glue + '"></a>' + marker);
            break;
        }
        $glue.addClass(boundClass + ' fn-' + type);
      },
      linkToTargets = function ($links, $targets) {
        var l,
          s,
          type,
          linkCount = 0,
          targetCount = 0,
          already,
          alreadyMarked = [],
          $link,
          $linkSubset,
          $linkCurrent,
          $target,
          currentTarget,
          adjustedLink;
        for (l = 0; l < $links.length; l++) {
          $linkCurrent = $links.eq(l);
          type = $linkCurrent.attr(attrType);
          if ($.inArray(type, alreadyMarked) === -1) {
            alreadyMarked.push(type);
            linkCount += 1;
            targetCount = 0;
            $linkSubset = $links.not('.' + boundClass).filter('[' + attrType + '=' + type + ']');
            $targets.not('.' + boundClass).filter('[' + attrType + '=' + type + ']').attr(attrOrder, 100 * linkCount + 99);
            for (s = 0; s < $linkSubset.length; s++) {
              $link = $linkSubset.eq(s);
              currentTarget = $link.attr(attrBase);
              $target = $targets.filter('[' + attrBase + '=' + currentTarget + ']');
              already = null;
              if ($target.length > 0) {
                already = $target.attr(attrRendered);
                adjustedLink = createMarker(type, already ? already : ++targetCount);
                $target.attr(attrRendered, $(adjustedLink).text());
                if (!already) {
                  $target.attr(attrOrder, 100 * linkCount + $links.index($link));
                }
                addVisualAndLink($link, adjustedLink);
                addVisualAndLink($target, adjustedLink);
              }
            }
          }
        }
      },
      $footnotes = $(footnoteWrapper, container),
      $markers = $(markerWrapper, container),
      $content = $(footnoteContainer);
    // Helpful jQuery plugins.
    //
    $.fn.cleanFootnoteMarker = function (type) {
      $.each(this, function () {
        var $marked = $(this),
          glue = '<span class="' + connectClass + '">&nbsp;</span>',
          marker = $marked.text().match(fnRegex);
        if (marker) {
          $marked.attr(attrBase, marker[0].replace(boundRegex, '$1')).attr(attrType, marker[0].replace(fnRegex, '$1')).attr(attrValue, marker[0].replace(fnRegex, '$2')).attr(attrFunction, type).html($.trim($marked.html().replace(fnRegex, glue)));
        }
      });
      return this;
    };
    $.fn.wrapFootnoteContent = function () {
      var i, $note;
      for (i = 0; i < this.length; i++) {
        $note = this.eq(i);
        $note.wrapInner('<span class="' + contentClass + '"></span>').addClass('cf').find('.' + connectClass).prependTo($note);
      }
      return this;
    };
    $.fn.sortBy = function (order) {
      var $group = $(this),
        sortByFootnote = function (a, b) {
          var aOrder = parseInt('0' + $(a).attr(attrOrder)),
            bOrder = parseInt('0' + $(b).attr(attrOrder));
          return aOrder < bOrder ? -1 : aOrder > bOrder ? 1 : 0;
        },
        $container = $('<div class="temporary"/>').insertBefore($group.filter(':first'));
      switch (order) {
        case 'footnote-order':
          $group = $group.sort(sortByFootnote);
          break;
      }
      $.map($group, function (val) {
        $container.append(val);
      });
      $container.children().unwrap();
      return $group;
    };
    // Move all footnotes into a special container
    $content.append($footnotes);
    // Get the footnote marker out of the footnote's
    //   text and save it into data attributes.
    $markers.cleanFootnoteMarker('link');
    $footnotes.cleanFootnoteMarker('footnote');
    // Wrap footnote content for positioning.
    $footnotes.wrapFootnoteContent();
    // Traverse each marker group and apply treatment where
    //   specific markers and related footnotes exist.
    linkToTargets($markers, $footnotes);
    // Reorder the display of the footnotes to match
    //   their order of appearance in the main content.
    $footnotes.sortBy('footnote-order');
    // Add content container to the page.
    if ($content.text() !== '') {
      $content.appendTo($(answer, container));
    }
  }
}

/**
* A class that deals with data and its processing.
*/
// todo- move the QA data processing code in this class
class QaAnswerModel {
  /**
  * Creates an instance of QaAnswerModel.
  * @param {object} settings - used to initialize module properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(settings) {
    this.settings = settings;
  }

  /**
  * Process and return data that is passed to this function
  * @returns {object}
  */
  getProcessedData() {
    return null;
  }
}

/**
* A class that binds data with the view and provide all client side behaviour
* for Site Search list section of search results layer.
*/
class SiteSearchController {
  /**
  * Creates an instance of SiteSearchController.
  * @param {object} options - used to initialize module properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(options) {
    this.siteSearchView = options.view;
    this.siteSearchModel = options.model;
    this.moduleInstance = options.moduleInstance;
    this.jcrHelper = this.moduleInstance.jcrHelper;
    this.container = options.container;
    this.siteSearchContainerClass = '.site-search';
    this.siteSearchContainer = null;
    this.toggleTextClass = '.toggle-text';
    this.cardId = '#global-search-results-flyout-wrapper';
    this.data = null;
  }

  /**
  * Called by module to initialize controller behaviour
  * @param {object} options - used to initialize behaviour.
  * @returns {void}
  */
  init(options = {}) {
    this.attachEvents(options);
  }

  /**
  * Subscribe to standard dom and custom events
  * @returns {void}
  */
  attachEvents() {
    this.moduleInstance.Events.sub('global.search.results-received', $.proxy(this.handleResultsReceived, this));
    const toggleText = $(this.container).find(this.toggleTextClass);
    toggleText.on('click', $.proxy(this.handleToggleText, this));
  }

  /**
  * Handler for global.search.results-received event and renders site
  * search list inside search results.
  * @param {object} args - event arguments .
  * @returns {void}
  */
  handleResultsReceived(args) {
    this.container = args.data.target;
    this.data = args.data;
    if (args.data.response.siteSearch.results.length === 0) {
      $(this.siteSearchContainerClass).hide();
    } else {
      $(this.siteSearchContainerClass).show();
      this.render(args.data);
      if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout') {
        $(this.container).find('.spa-card__foot').show();
        let footerLink = $(this.container).find('.spa-card__foot').find('.spa-global-search-result-view--all');
        footerLink.attr('href', args.data.response.resultsCardsSettings.foot.data[0].URL);
      } else {
        $(this.container).find('#global-search-result-pagination').show();
      }
    }
  }

  /**
  * Renders site search section of search results
  * @param {object} data - data that need to be binded to the view.
  * @returns {void}
  */
  render(data = {}) {
    const view = this.siteSearchView.getView();
    const processedData = this.siteSearchModel.getProcessedData(data);
    if (view) {
      const target = this.container.find(this.siteSearchContainerClass);
      $(target).html(view({
        data: processedData
      }));
      if (this.moduleInstance.resultsExperience && this.moduleInstance.resultsExperience.toLowerCase() === 'flyout' && data.response.config.isAnswerPresent == true) {
        this.siteSearchView.hideRecordsAboveLimit(target);
      }
      const aToggle = $(this.container).find(this.toggleTextClass);
      const divAnswerContainer = $(aToggle).parent();
      const divAnswer = $(divAnswerContainer).find('.answer');
      // in FAQ few answers are hidden in the response from search 
      let allHiddenAnsDivs = $(divAnswer).find('div[hidden]');
      if (allHiddenAnsDivs && allHiddenAnsDivs.length > 0) {
        allHiddenAnsDivs.removeAttr("hidden");
      }
      for (let i = 0; i < divAnswer.length; i++) {
        let partialAnswer = this.siteSearchView.getPartialAnswer(divAnswer[i], true);
        if (partialAnswer) {
          $(aToggle[i]).show();
          $(aToggle[i]).attr('aria-expanded', 'false');
          $(aToggle[i]).on('click', $.proxy(this.handleToggleText, this));
          partialAnswer.attr('aria-expanded', 'false');
          $(divAnswer[i]).attr('tabindex', '-1');
          $(divAnswer[i]).hide();
        } else {
          $(aToggle[i]).hide();
        }
      }
      const divSearch = $(target).find('.spa-global-search-managed-top-result--text');
      for (let i = 0; i < divAnswer.length; i++) {
        let partialSearch = this.siteSearchView.getPartialAnswer(divSearch[i], false);
        if (partialSearch) {
          $(divSearch[i]).hide();
        }
      }
    }
  }

  /**
  * Show More or Less functionality implementation
  * @param {object} event - data that need to be validated and processed.
  * @returns {void}
  */
  handleToggleText(event) {
    const dvContainer = $(event.target).parents('.answer-container');
    $(dvContainer).prev();
    const aToggle = $(dvContainer).find(this.toggleTextClass);
    const divAnswers = $(dvContainer).find('.answer');
    if ($(aToggle).attr('aria-expanded') == 'true') {
      //when full answer was displayed 
      divAnswers.first().attr('aria-expanded', 'false');
      divAnswers.first().show(); //show partial answer
      divAnswers.last().hide(); //hide full answer
      $(aToggle).attr('aria-expanded', 'false');
      $(aToggle).find('.toggle-text-span').html(this.data.response.labels.siteSearchShowFull);
    } else {
      divAnswers.last().attr('aria-expanded', 'true');
      const divFullAns = divAnswers.last().find('div[hidden=hidden]');
      if (divFullAns) {
        divFullAns.removeAttr('hidden');
      }
      divAnswers.last().show(); //show full answer
      divAnswers.last().focus();
      divAnswers.first().hide(); //hide partial answer
      $(aToggle).attr('aria-expanded', 'true');
      $(aToggle).find('.toggle-text-span').html(this.data.response.labels.siteSearchHideFull);
    }
  }
}

/**
* A class that fetch handlebars view and provide all view or markup related processing.
*/
class SiteSearchView {
  /**
  * Creates an instance of ResultsView.
  * @param {object} options - used to initialize view properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(options) {
    this.moduleInstance = options.moduleInstance;
  }

  /**
  * Called by controller to fetch view template that needs to be binded with the data.
  * @returns {object}
  */
  getView() {
    return moduleConfig.partials['results-site-search'];
  }

  /**
  * Called by controller to enforce limit on number of searches to be displayed
  */
  hideRecordsAboveLimit(container) {
    const threshold = this.moduleInstance.jcrHelper.getSettings({
      key: 'searchAnswerDisplayLimitWithManagedCard',
      default: ''
    });
    if (threshold && threshold > -1) {
      container.find('.spa-global-search-result-info--list-info, .spa-global-search-result-faq--list').slice(threshold).hide();
    }
  }

  /**
  * Called by controller to enforce limit on number of lines to be displayed
  */
  getPartialAnswer(container, isFAQ) {
    const threshold = this.moduleInstance.jcrHelper.getSettings({
      key: 'searchAnswerLineLimit',
      default: ''
    });
    if (threshold && threshold > -1) {
      const regWhitespace = /(\t+|\n+|\s{2,})/g;
      let clone = $(container).clone();
      //$(container).parent().prepend(clone);
      $(clone).insertBefore(container);
      let cloneLabel = clone.children('.spa-global-search-result-faq--ans, .ada-hidden').clone();
      clone.find('.spa-global-search-result-faq--ans, .ada-hidden').remove();
      const innerText = clone.text().replace(regWhitespace, ' ').replace(regWhitespace, ' ');
      clone.html('').append(cloneLabel);
      let words = innerText.split(' ');
      let initialHeight = clone.height();
      let newHeight = clone.height();
      let lineCount = 0;
      for (let i = 0; i < words.length; i++) {
        if ($.trim(words[i]) != '') {
          clone.html(clone.html() + $.trim(words[i]) + ' ');
          newHeight = clone.height();
          if (initialHeight != newHeight) {
            initialHeight = newHeight;
            lineCount++;
            if (lineCount > threshold) {
              let str = clone.html();
              let lastIndex = str.lastIndexOf(words[i] + ' ');
              if (str.length > lastIndex) {
                str = str.substring(0, lastIndex);
              }
              if (!isFAQ) {
                lastIndex = str.trim().lastIndexOf(' ');
                if (str.length > lastIndex) {
                  str = str.substring(0, lastIndex) + '<span class="ellipsis"> ...</span>';
                }
              }
              clone.html(str);
              return clone;
            }
          }
        }
      }
      clone.remove();
    }
    return null;
  }
}

/**
* A class that deals with data and its processing.
*/
class SiteSearchModel {
  /**
  * Creates an instance of SiteSearchModel.
  * @param {object} options - used to initialize module properties .
  * @memberof GlobalSearchResultsModule
  */
  constructor(options) {
    this.settings = options.settings;
    this.moduleInstance = options.moduleInstance;
    this.isFullSearch = false;
    this.itemLimit = null;
  }

  /**
  * Process and return data that is passed to this function
  * @param {object} options - used to pass data that need to be processed
  * @returns {object}
  */
  getProcessedData(options = {}) {
    this.data = this.processResults(options.response);
    const page = 1;
    const pageCount = 1;
    const results = this.itemLimit === null ? this.data.siteSearch.results : this.data.siteSearch.results.slice(0, this.itemLimit);
    this.data.siteSearch.showHeading = !(this.data.spellingCorrected && this.data.qa.answer.length === 0);
    this.data.siteSearch.showFullHeading = this.isFullSearch;
    this.data.siteSearch.showResults = results.length > 0;
    this.data.siteSearch.results = results;
    this.data.siteSearch.pageNumber = null;
    this.data.siteSearch.lastPage = page === pageCount;
    return this.data;
  }

  /**
  * Process and return response that is passed to this function
  * @param {object} response - used to pass data that need to be processed
  * @returns {object}
  */
  processResults(response) {
    const search = response.siteSearch;
    const {
      results
    } = search;
    search.first;
    let l = results.length;
    const answerType = 'answer_type';
    let i;
    let type;
    let target;
    const brain = new GlobalSearchBrainUtility({
      isAuth: this.moduleInstance.isAuth,
      moduleInstance: this.moduleInstance
    });
    for (i = 0; i < l; i++) {
      // Open the link in a new window when appropriate.
      target = brain.newWindow(results[i].url);
      if (target !== '') {
        results[i].window = target;
      }
      // type
      type = results[i][answerType];
      results[i].answerType = type;
      const TYPES = {
        FAQ: 'faq',
        BRAIN: 'olb-url',
        MANAGED: 'olb-dynamic'
      };
      switch (type) {
        case TYPES.FAQ:
          results[i].isFaq = true;
          this.processFaq(results[i]);
          break;
        case TYPES.MANAGED:
          results.splice(i, 1);
          i -= 1;
          l -= 1;
          continue;
        // process brain urls
        case TYPES.BRAIN:
          results[i].window = '';
          results[i].isBrain = true;
          results[i].url = brain.fullUrl(results[i].target, GlobalSearchCommonUtility.string.insecure(response.correctedQuery));
          results[i].language = GlobalSearchCommonUtility.lang.getPageLanguage();
          break;
      }
      // add an iterator to the result for enumerating
      results[i].count = i + 1;
    }
    return response;
  }

  /**
  * Process and return faq markup returned in the service response
  * @param {object} result - faq data to be processed
  * @returns {void}
  */
  processFaq(result) {
    let answerContainer = $('<div/>').html($.trim(result.answer));
    answerContainer.find('a:contains("Expand all panels")').remove();
    answerContainer.find('[class]').removeAttr('class');
    answerContainer.find('[id]').removeAttr('id');
    answerContainer.find('[style]').removeAttr('style');
    answerContainer.find('a[target]').removeAttr('target');
    answerContainer = this.trimContainers(answerContainer);
    this.removeEmptyElements(answerContainer);
    this.removeLeadingBreaks(answerContainer);
    let answerHtml = $.trim(answerContainer.html());
    answerHtml = answerHtml.replace(/<p( [^>]*)?>([\u00a0\t\r\n]|&nbsp;)*<br\/?>/gi, '<p$1>');
    result.answer = answerHtml;
  }

  /**
  * Remove unnecessory containers present inside the markup returned by the service.
  * @param {object} element - orphan dom object holding the markup.
  * @returns {object}
  */
  trimContainers(element) {
    const containers = /^(div|li|span)$/i;
    const container = /^[ \t\n\r]*<[\s\S]*>[ \t\r\n]*$/;
    const children = element.children();
    if (children.length === 1 && containers.test(children.eq(0).attr('tagName')) && container.test(element.html())) {
      return this.trimContainers(children);
    }
    return element;
  }

  /**
  * Remove empty elements present inside the markup returned by the service.
  * @param {object} element - dom object holding the markup.
  * @returns {void}
  */
  removeEmptyElements(element) {
    const empty = /^([ \u00a0\t\r\n]|&nbsp;)*$/;
    let child;
    const children = element.find('div:not(:has(*)),p:not(:has(*)),ul:not(:has(*)),li:not(:has(*))');
    const l = children.length;
    for (let i = 0; i < l; i++) {
      child = children.eq(i);
      if (empty.test(child.html())) {
        child.remove();
      }
    }
  }

  /**
  * Remove breaks present inside the markup returned by the service.
  * @param {object} element - dom object holding the markup.
  * @returns {void}
  */
  removeLeadingBreaks(element) {
    let child;
    const children = element.find('p,li');
    const l = children.length;
    for (let i = 0; i < l; i++) {
      child = children.eq(i);
      child.find('br').replaceWith('<br/>');
      child.html(child.html().replace(/^([ \t\r\n]*<br\/?>)+/i, ''));
    }
  }
}

const Template$4 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate$4 = function (data, options) {
  return Template$4(data, options);
};

const Template$3 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <a class=\"spa-global-search-managed-top-result--suggest-link spa-global-search-result--link\"\r\n      href=\"javascript:void(0);\">\r\n      "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"autoCorrectSearch") : stack1), depth0))
    + " "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"rawQuery") : stack1), depth0))
    + "\r\n    </a>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"answer authenticated cf\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"qa") : stack1)) != null ? lookupProperty(stack1,"answer") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"answer not-authenticated cf\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"qa") : stack1)) != null ? lookupProperty(stack1,"answer") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"spa-global-search-managed-top-result--container\">\r\n  <div class=\"spa-global-search-managed-top-result--header\">\r\n    <h3 id=\"global-search-managed-content\"\r\n      class=\"spa-global-search-managed-top-result--toptitle spa-global-search-result--title\" tabindex=\"0\">\r\n      "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"qaTopResult") : stack1), depth0))
    + "\r\n      <span class=\"spa-global-search-managed-top-result--bold spa-global-search-result--bold\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"query") : stack1), depth0))
    + "</span>\r\n    </h3>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"config") : stack1)) != null ? lookupProperty(stack1,"showCorrection") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":13,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div\r\n    class=\"qa-answer live-results spa-global-search-managed-top-result-ans--container spa-global-search-result-managed--data\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"config") : stack1)) != null ? lookupProperty(stack1,"isAuth") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":17,"column":4},"end":{"line":25,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>";
},"useData":true});
const renderTemplate$3 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$3(data, options);
};

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <h3 id=\"global-search-site-search\"\r\n      class=\"spa-global-search-managed-top-result--title spa-global-search-result--othertitle\" tabindex=\"0\">\r\n      "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"otherResults") : stack1), depth0))
    + "\r\n    </h3>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"spa-global-search-managed-top-result--header\">\r\n      <h3 id=\"global-search-site-search\"\r\n        class=\"spa-global-search-managed-top-result--title spa-global-search-result--title\" tabindex=\"0\">\r\n        "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"siteSearchHeading") : stack1), depth0))
    + "\r\n        <span class=\"spa-global-search-managed-top-result--bold spa-global-search-result--bold\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"query") : stack1), depth0))
    + "</span>\r\n      </h3>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"config") : stack1)) != null ? lookupProperty(stack1,"showCorrection") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":6},"end":{"line":20,"column":13}}})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <a class=\"spa-global-search-managed-top-result--suggest-link spa-global-search-result--link\"\r\n        href=\"javascript:void(0);\">\r\n        "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"autoCorrectSearch") : stack1), depth0))
    + " "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"rawQuery") : stack1), depth0))
    + "\r\n      </a>\r\n";
},"6":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isFaq") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.program(14, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":25,"column":6},"end":{"line":92,"column":13}}})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li role=\"listitem\" class=\"spa-global-search-result-faq--list spa-global-search-result-faqinfo--data\">\r\n        <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"url") || (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"url","hash":{},"data":data,"loc":{"start":{"line":27,"column":17},"end":{"line":27,"column":24}}}) : helper)))
    + "\" class=\"spa-global-search-managed-top-result--link spa-global-search-result-info--link\"\r\n          data-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":28,"column":19},"end":{"line":28,"column":25}}}) : helper)))
    + "\" name=\"search-module-search-results-result-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"count") || (depth0 != null ? lookupProperty(depth0,"count") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"count","hash":{},"data":data,"loc":{"start":{"line":28,"column":69},"end":{"line":28,"column":78}}}) : helper)))
    + "\"\r\n          data-bactmln=\"search-module-search-results-result-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"count") || (depth0 != null ? lookupProperty(depth0,"count") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"count","hash":{},"data":data,"loc":{"start":{"line":29,"column":60},"end":{"line":29,"column":69}}}) : helper)))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"window") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":71},"end":{"line":29,"column":113}}})) != null ? stack1 : "")
    + ">\r\n          <span class=\"spa-global-search-result-faq--ans spa-global-search-result-faqinfo--ans\" aria-hidden=\"true\">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"siteSearchFaqQ") : stack1), depth0))
    + "\r\n          </span>\r\n          <span class=\"ada-hidden\">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"siteSearchFaqQFullForm") : stack1), depth0))
    + "\r\n          </span>\r\n          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"highlightedTitle") || (depth0 != null ? lookupProperty(depth0,"highlightedTitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"highlightedTitle","hash":{},"data":data,"loc":{"start":{"line":36,"column":10},"end":{"line":36,"column":32}}}) : helper))) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.program(12, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":37,"column":10},"end":{"line":40,"column":17}}})) != null ? stack1 : "")
    + "        </a>\r\n        <div class=\"answer-container\">\r\n          <div class=\"answer\">\r\n            <span class=\"spa-global-search-result-faq--ans spa-global-search-result-faqinfo--ans\" aria-hidden=\"true\">\r\n              "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"siteSearchFaqA") : stack1), depth0))
    + "\r\n            </span>\r\n            <span class=\"ada-hidden\">\r\n              "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"siteSearchFaqAFullForm") : stack1), depth0))
    + "\r\n            </span>\r\n            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"answer") || (depth0 != null ? lookupProperty(depth0,"answer") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"answer","hash":{},"data":data,"loc":{"start":{"line":50,"column":12},"end":{"line":50,"column":24}}}) : helper))) != null ? stack1 : "")
    + "\r\n          </div>\r\n          <div class=\"faq-toggle-text-seperator\"></div>\r\n          <button class=\"spa-btn spa-btn--link toggle-text\" type=\"button\">\r\n            <span class=\"toggle-text-span\">\r\n              "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"siteSearchShowFull") : stack1), depth0))
    + "\r\n            </span>\r\n            <span class=\"ada-hidden\">\r\n              "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"for") : stack1), depth0))
    + "\r\n              "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"highlightedTitlePlainText") || (depth0 != null ? lookupProperty(depth0,"highlightedTitlePlainText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"highlightedTitlePlainText","hash":{},"data":data,"loc":{"start":{"line":59,"column":14},"end":{"line":59,"column":43}}}) : helper)))
    + "\r\n            </span>\r\n          </button>\r\n        </div>\r\n      </li>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " target=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"window") || (depth0 != null ? lookupProperty(depth0,"window") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"window","hash":{},"data":data,"loc":{"start":{"line":29,"column":94},"end":{"line":29,"column":104}}}) : helper)))
    + "\" ";
},"10":function(container,depth0,helpers,partials,data) {
    return "";
},"12":function(container,depth0,helpers,partials,data) {
    return "          UNTITLED\r\n";
},"14":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <li role=\"listitem\" class=\"spa-global-search-result-info--list-info\">\r\n        <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"url") || (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"url","hash":{},"data":data,"loc":{"start":{"line":66,"column":17},"end":{"line":66,"column":24}}}) : helper)))
    + "\" class=\"spa-global-search-managed-top-result--link spa-global-search-result-info--link\"\r\n          data-id=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"id") || (depth0 != null ? lookupProperty(depth0,"id") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"id","hash":{},"data":data,"loc":{"start":{"line":67,"column":19},"end":{"line":67,"column":25}}}) : helper)))
    + "\" name=\"search-module-search-results-result-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"count") || (depth0 != null ? lookupProperty(depth0,"count") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"count","hash":{},"data":data,"loc":{"start":{"line":67,"column":69},"end":{"line":67,"column":78}}}) : helper)))
    + "\"\r\n          data-bactmln=\"search-module-search-results-result-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"count") || (depth0 != null ? lookupProperty(depth0,"count") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"count","hash":{},"data":data,"loc":{"start":{"line":68,"column":60},"end":{"line":68,"column":69}}}) : helper)))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"window") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":68,"column":71},"end":{"line":68,"column":113}}})) != null ? stack1 : "")
    + ">\r\n          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"highlightedTitle") || (depth0 != null ? lookupProperty(depth0,"highlightedTitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"highlightedTitle","hash":{},"data":data,"loc":{"start":{"line":69,"column":10},"end":{"line":69,"column":32}}}) : helper))) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.program(12, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":70,"column":10},"end":{"line":73,"column":17}}})) != null ? stack1 : "")
    + "        </a>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"text_content") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":75,"column":8},"end":{"line":79,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isBrain") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":80,"column":8},"end":{"line":90,"column":15}}})) != null ? stack1 : "")
    + "      </li>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"spa-global-search-managed-top-result--text spa-global-search-result-info--text\">\r\n          "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"highlightedAnswer") || (depth0 != null ? lookupProperty(depth0,"highlightedAnswer") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"highlightedAnswer","hash":{},"data":data,"loc":{"start":{"line":77,"column":10},"end":{"line":77,"column":33}}}) : helper))) != null ? stack1 : "")
    + "\r\n        </p>\r\n";
},"17":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"config") : stack1)) != null ? lookupProperty(stack1,"isAuth") : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.program(18, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":81,"column":8},"end":{"line":89,"column":15}}})) != null ? stack1 : "");
},"18":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"spa-global-search-result-info--action\">\r\n          <span class=\"spa-icon icon-lock\"></span>\r\n          <span class=\"spa-global-search-result-info-action--text spa-global-search-result--action\">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data") : depths[1])) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"authenticatedLinkMessage") : stack1), depth0))
    + "\r\n          </span>\r\n        </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"spa-global-search-managed-top-result--container spa-global-search-result-info--data\">\r\n  <div class=\"spa-global-search-managed-top-result--section spa-global-search--partial\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"config") : stack1)) != null ? lookupProperty(stack1,"isAnswerPresent") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.program(3, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":21,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n    <ul class=\"spa-global-search-managed-top-result--list spa-global-search-result-info--list\" role=\"list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"siteSearch") : stack1)) != null ? lookupProperty(stack1,"results") : stack1),{"name":"each","hash":{},"fn":container.program(6, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":6},"end":{"line":93,"column":15}}})) != null ? stack1 : "")
    + "    </ul>\r\n  </div>\r\n</div>";
},"useData":true,"useDepths":true});
const renderTemplate$2 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"cardHelper")||(depth0 && lookupProperty(depth0,"cardHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"partials") : depth0),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"resultsCardsSettings") : stack1),{"name":"cardHelper","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":49}}}))
    + "\r\n<div class=\"spa-global-search--flyout spa-global-search-results-container\">\r\n  <div id=\"global-search-input-container-md\"></div>\r\n  <span class=\"ada-hidden\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"beginLayer") : stack1), depth0))
    + "</span>\r\n  <div class=\"spa-global-search--partial-list spa-global-search--sections\">\r\n    <div id=\"global-search-throbber\" class=\" throbber\" tabindex=\"0\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"spinner")||(depth0 && lookupProperty(depth0,"spinner"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"resultsSpinner") : stack1),{"name":"spinner","hash":{},"data":data,"loc":{"start":{"line":7,"column":6},"end":{"line":7,"column":39}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <!-- Managed Content -->\r\n    <div class=\"search-container managed-content spa-global-search-top-managed-result spa-global-search--partial\">\r\n    </div>\r\n    <!-- Search Results -->\r\n    <div class=\"site-search live-results spa-global-search-top-managed-result spa-global-search--partial\">\r\n    </div>\r\n\r\n    <!-- Search Unavailable -->\r\n    <div id=\"global-search-outage\" class=\"outage spa-global-search-tips spa-global-search--partial\" role=\"alert\"\r\n      tabindex=\"0\">\r\n      <div class=\" spa-global-search-tips--container\">\r\n        <div class=\"spa-icon icon-warning--red spa-global-search-tips--alert\"></div>\r\n        <div class=\"spa-global-search-tips--label\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"outageIntro") : stack1), depth0))
    + "</div>\r\n        <p class=\"spa-global-search-tips--title outage-content\">\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"outageApology") : stack1), depth0))
    + "\r\n          <a name=\"search-module-noresults-help-and-suport\" data-bactmln=\"search-module-noresults-help-and-suport\"\r\n            class=\"track-me\" href="
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"links") : stack1)) != null ? lookupProperty(stack1,"helpSupport") : stack1), depth0))
    + ">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"outageAuthHelpSupport") : stack1), depth0))
    + "\r\n          </a>\r\n        </p>\r\n      </div>\r\n    </div>\r\n    <!-- Empty Search -->\r\n    <div id=\"global-search-empty-search\" class=\"empty-search spa-global-search-tips spa-global-search--partial\"\r\n      role=\"alert\" tabindex=\"0\">\r\n      <div class=\" spa-global-search-tips--container\">\r\n        <div class=\"spa-global-search-tips--label\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"emptySearchTipsText") : stack1), depth0))
    + "</div>\r\n        <h3 class=\"spa-global-search-tips--title\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"emptySearchTipsTitle") : stack1), depth0))
    + "</h3>\r\n        <ul class=\"spa-global-search-tips--list\" role=\"list\">\r\n          <li role=\"listitem\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsTip1") : stack1), depth0))
    + "</li>\r\n          <li role=\"listitem\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsTip2") : stack1), depth0))
    + "</li>\r\n          <li role=\"listitem\">\r\n            <a name=\"search-module-noresults-help-and-suport\" data-bactmln=\"search-module-noresults-help-and-suport\"\r\n              class=\"track-me\" href="
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"links") : stack1)) != null ? lookupProperty(stack1,"helpSupport") : stack1), depth0))
    + ">\r\n              "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsHelpAndSupport") : stack1), depth0))
    + "\r\n            </a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n    <!-- No Results -->\r\n    <div id=\"global-search-no-results\" class=\"no-results spa-global-search-tips spa-global-search--partial\" role=\"alert\"\r\n      tabindex=\"0\">\r\n      <div class=\" spa-global-search-tips--container\">\r\n        <div class=\"spa-global-search-tips--label\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsPageApology") : stack1), depth0))
    + "</div>\r\n        <p class=\"spa-global-search-tips--title\">\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsPageSuggestions") : stack1), depth0))
    + "\r\n          <a name=\"search-module-noresults-help-and-suport\" data-bactmln=\"search-module-noresults-help-and-suport\"\r\n            class=\"track-me\" href="
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"links") : stack1)) != null ? lookupProperty(stack1,"helpSupport") : stack1), depth0))
    + ">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"outageAuthHelpSupport") : stack1), depth0))
    + "\r\n          </a>\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"spa-global-search-results-container\">\r\n  <div class=\"spa-global-search--sections\">\r\n    <div id=\"global-search-throbber\" class=\"throbber\" tabindex=\"-1\">\r\n      "
    + ((stack1 = (lookupProperty(helpers,"spinner")||(depth0 && lookupProperty(depth0,"spinner"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"resultsSpinner") : stack1),{"name":"spinner","hash":{},"data":data,"loc":{"start":{"line":4,"column":6},"end":{"line":4,"column":39}}})) != null ? stack1 : "")
    + "\r\n    </div>\r\n    <!-- Managed Content -->\r\n    <div class=\"search-container managed-content spa-global-search-top-managed-result spa-global-search-result--info\">\r\n    </div>\r\n    <!-- Search Results -->\r\n    <div\r\n      class=\"site-search live-results spa-global-search-top-managed-result spa-global-search--partial spa-global-search-result--info\">\r\n    </div>\r\n\r\n    <!-- Search Unavailable -->\r\n    <div id=\"global-search-outage\" class=\"outage spartaMessage error large\" role=\"alert\" tabindex=\"0\">\r\n      <div class=\"spartaMessage-icon\">\r\n        <span class=\"ada-hidden\">warning icon</span>\r\n        <span class=\"data-icon\"></span>\r\n      </div>\r\n      <div class=\"spartaMessage-content\">\r\n        <p class=\"spartaMessage-title\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"outagePageIntro") : stack1), depth0))
    + "</p>\r\n        <p class=\"spartaMessage-text\">\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"outagePageApology") : stack1), depth0))
    + "\r\n          <a name=\"search-module-outage-help-and-suport\" data-bactmln=\"search-module-outage-help-and-suport\"\r\n            class=\"track-me\" href="
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"links") : stack1)) != null ? lookupProperty(stack1,"helpSupport") : stack1), depth0))
    + ">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"outageAuthHelpSupport") : stack1), depth0))
    + "\r\n          </a>\r\n        </p>\r\n      </div>\r\n    </div>\r\n    <!-- Empty Search -->\r\n    <div id=\"global-search-empty-search\" class=\"empty-search spartaMessage warning large\" role=\"alert\" tabindex=\"0\">\r\n      <div class=\"spartaMessage-icon\">\r\n        <span class=\"ada-hidden\">warning icon</span>\r\n        <span class=\"data-icon\"></span>\r\n      </div>\r\n      <div class=\"spartaMessage-content  \">\r\n        <p class=\"spartaMessage-text\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"emptySearchTipsText") : stack1), depth0))
    + "</p>\r\n        <p class=\"spartaMessage-title\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"emptySearchTipsTitle") : stack1), depth0))
    + "</p>\r\n        <ul class=\"spa-global-search-tips--list\" role=\"list\">\r\n          <li role=\"listitem\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsTip1") : stack1), depth0))
    + "</li>\r\n          <li role=\"listitem\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsTip2") : stack1), depth0))
    + "</li>\r\n          <li role=\"listitem\">\r\n            <a name=\"search-module-noresults-help-and-suport\" data-bactmln=\"search-module-noresults-help-and-suport\"\r\n              class=\"track-me\" href="
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"links") : stack1)) != null ? lookupProperty(stack1,"helpSupport") : stack1), depth0))
    + ">\r\n              "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsHelpAndSupport") : stack1), depth0))
    + "\r\n            </a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n    <!-- No Results -->\r\n    <div id=\"global-search-no-results\" class=\"no-results spartaMessage warning large\" role=\"alert\" tabindex=\"0\">\r\n      <div class=\"spartaMessage-icon\">\r\n        <span class=\"ada-hidden\">warning icon</span>\r\n        <span class=\"data-icon\"></span>\r\n      </div>\r\n      <div class=\"spartaMessage-content\">\r\n        <p class=\"spartaMessage-title\">"
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsPageApology") : stack1), depth0))
    + "</p>\r\n        <p class=\"spartaMessage-text\">\r\n          "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"noResultsPageSuggestions") : stack1), depth0))
    + "\r\n          <a name=\"search-module-noresults-help-and-suport\" data-bactmln=\"search-module-noresults-help-and-suport\"\r\n            class=\"track-me\" href="
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"links") : stack1)) != null ? lookupProperty(stack1,"helpSupport") : stack1), depth0))
    + ">\r\n            "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"labels") : stack1)) != null ? lookupProperty(stack1,"outageAuthHelpSupport") : stack1), depth0))
    + "\r\n          </a>\r\n        </p>\r\n      </div>\r\n    </div>\r\n    <div class=\"spa-global-search-result-pagination\" id=\"global-search-result-pagination\">\r\n      \r\n    </div>\r\n  </div>\r\n</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global-gt.modules/global-search-results-module",
  "version": "1.0.10",
  "id": "globalSearchResultsModule",
  "containerID": "globalGtGlobalSearchResultsModule",
  "moduleName": "global-gt-global-search-results-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "global-search-results-module",
  "data": {
    "init": "GlobalSearchResultsModule",
    "options": {
      "globalSearchJcr": "{{json globalSearchJcr}}"
    }
  },
  "moduleParams": [{
    "name": "isAuth",
    "type": "boolean",
    "description": "This parameter controls the rendering of module in authenticated vs unauthenticated mode. The default is false.",
    "default": false,
    "values": [true, false]
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$4(context, {
      "helpers": {
        cardHelper,
        spinner,
        paginationHelper
      },
      "partials": {
        "results-qa-answers": renderTemplate$3,
        "results-site-search": renderTemplate$2,
        "search-results-container-flyout": renderTemplate$1,
        "search-results-container-inline": renderTemplate
      }
    });
  },
  "template": renderTemplate$4,
  "partials": {
    "results-qa-answers": renderTemplate$3,
    "results-site-search": renderTemplate$2,
    "search-results-container-flyout": renderTemplate$1,
    "search-results-container-inline": renderTemplate
  },
  "helpers": {
    cardHelper,
    spinner,
    paginationHelper
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-spinner-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-transport-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-pagination-utility": "^1.0.0",
    "@sparta.global-gt.utilities/global-search-brain-utility": "^1.0.0",
    "@sparta.global-gt.utilities/global-search-common-utility": "^1.0.0",
    "@sparta.global-gt.utilities/global-search-jcr-utility": "^1.0.0",
    "@sparta.global-gt.utilities/global-search-tracking-utility": "^1.0.0",
    "@sparta.global.helpers/card-helper": "^1.0.0",
    "@sparta.global.helpers/spinner-helper": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.7.1",
    "@sparta.global.vendors/handlebars": "^4.7.7",
    "@sparta.global.helpers/pagination-helper": "^1.0.0"
  },
  "stores": []
};

/**
 * Implementation of the global-search-results-module module.
 * @copyright 2021-7-26
 * @since 7/26/2021, 6:18:57 AM
 * @author Daware, Mahendra
 * @file
 */

/* global Module */

/**
 * The GlobalSearchResultsModule Sparta Module.
 * This module is responsible for UI and behaviour of search results.
 * @export
 * @class
 */
class GlobalSearchResultsModule extends Module {
  /**
   * Creates an instance of GlobalSearchResultsModule.
   * @param {object} options - used to initialize module.
   * @memberof GlobalSearchResultsModule
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.site = 'OLB';
    this.lang = 'en';
    this.inputExperience = 'header';
    this.resultsExperience = 'flyout';
    this.resultsContainerId = '';
    this.isAuth = false;
    this.jcrHelper = null;
    this.Widget = window.spaWidgetParams[this.applicationContext.name][this.applicationContext.version][this.applicationContext.id];
    this.imports = {
      ResultsController,
      ResultsView,
      ResultsModel,
      QaAnswerController,
      QaAnswerView,
      QaAnswerModel,
      SiteSearchController,
      SiteSearchView,
      SiteSearchModel
    };
  }

  /**
   * Called when this module is bootstrapped by the client
   * @returns {void}
   */
  init() {
    this.site = GlobalSearchCommonUtility.site.getCurrentSite();
    this.lang = GlobalSearchCommonUtility.lang.getPageLanguage();
    this.isAuth = this.params && this.params.isAuth;
    const widgetOptionsStr = JSON.parse(this.applicationContainer.getAttribute('data-sparta-options'));
    if (widgetOptionsStr.inputExperience) {
      this.inputExperience = widgetOptionsStr.inputExperience;
    }
    if (widgetOptionsStr.resultsExperience) {
      this.resultsExperience = widgetOptionsStr.resultsExperience;
    }
    if (widgetOptionsStr.resultsContainerId) {
      this.resultsContainerId = widgetOptionsStr.resultsContainerId;
    }
    this.jcrHelper = new GlobalSearchJcrUtility({
      site: this.site,
      searchJcrData: this.settings.globalSearchJcr,
      moduleInstance: this
    });
    const componentsSetting = this.jcrHelper.getComponentsSetting({
      inputExperience: this.inputExperience,
      resultsExperience: this.resultsExperience,
      componentName: 'results'
    });
    const viewType = componentsSetting.view.type;
    const view = new this.imports[viewType]({
      settings: componentsSetting.view.attributes,
      moduleInstance: this
    });
    const modelType = componentsSetting.model.type;
    const model = new this.imports[modelType]({
      settings: componentsSetting.model.dataServices,
      moduleInstance: this
    });
    let container = this.settings.$target;
    if (this.resultsExperience && this.resultsExperience.toLowerCase() === 'inline' && this.resultsContainerId) {
      container = $(`#${this.resultsContainerId}`);
    }
    const controllerType = componentsSetting.controller.type;
    const controller = new this.imports[controllerType]({
      view,
      model,
      container,
      moduleInstance: this
    });
    controller.init();
    for (let i = 0; i < componentsSetting.childs.length; i++) {
      const viewTypeChild = componentsSetting.childs[i].view.type;
      const viewChild = new this.imports[viewTypeChild]({
        settings: componentsSetting.childs[i].view.attributes,
        moduleInstance: this
      });
      const modelTypeChild = componentsSetting.childs[i].model.type;
      const modelChild = new this.imports[modelTypeChild]({
        settings: componentsSetting.childs[i].model.dataServices,
        moduleInstance: this
      });
      const controllerTypeChild = componentsSetting.childs[i].controller.type;
      const controllerChild = new this.imports[controllerTypeChild]({
        view: viewChild,
        model: modelChild,
        container,
        moduleInstance: this
      });
      controllerChild.init();
    }
  }
}
registerModuleClass({
  moduleClass: GlobalSearchResultsModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { GlobalSearchResultsModule as default, moduleConfig };
